import { computed, Directive, inject, input } from '@angular/core';
import { BreakpointService } from '@big-direkt/utils/shared';

@Directive({
    selector: 'td[bigUiTableCell]',
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': 'classList()',
    },
})
export class TableCellDirective {
    private readonly breakpointService = inject(BreakpointService);

    private readonly baseDesktopClasses = [
        'align-top',
        'border-r-2',
        'last:border-r-0',
    ];
    private readonly evenOddDesktopClasses = [
        'group-odd/row:bg-primary-100',
        'group-even/row:bg-primary-50',
        'dark:group-even/row:bg-primary-600',
        'dark:group-odd/row:bg-primary-500',
        'group-odd/row:not-last:border-r-primary-50',
        'group-even/row:not-last:border-r-primary-100',
        'dark:group-even/row:not-last:border-r-primary-600',
        'dark:group-odd/row:not-last:border-r-primary-500',
    ];
    private readonly firstCellMobileClasses = [
        'bg-primary',
        'dark:bg-primary-700',
        'text-white',
    ];
    private readonly nonFirstCellMobileClasses = [
        'even:bg-primary-100',
        'odd:bg-primary-50',
        'even:dark:bg-primary-500',
        'odd:dark:bg-primary-600',
    ];
    private readonly commonMobileClasses = [
        'block',
        'border-r-0',
        'last:mb-8',
    ];

    public readonly customClasses = input<string>();
    public readonly disableEvenOdd = input(false);
    public readonly isFirst = input(false);
    public readonly noPadding = input(false);
    public readonly renderResponsive = input(false);

    public readonly classList = computed(() => {
        const isMobile = this.breakpointService.isMobile();
        const isResponsiveMobile = isMobile && this.renderResponsive();
        const classes = [];

        if (!isResponsiveMobile) {
            classes.push(...this.baseDesktopClasses);
        }

        if (!this.noPadding()) {
            classes.push('p-3');
        }

        if (!this.disableEvenOdd() && !isResponsiveMobile) {
            classes.push(...this.evenOddDesktopClasses);
        }

        if (isResponsiveMobile) {
            classes.push(...this.commonMobileClasses);

            if (this.isFirst()) {
                classes.push(...this.firstCellMobileClasses);
            } else {
                classes.push(...this.nonFirstCellMobileClasses);
            }
        }

        const customClassValue = this.customClasses();
        if (customClassValue) {
            classes.push(customClassValue);
        }

        return classes.join(' ');
    });
}
